import executeApi from './executeApi';
import { fetchAuthSession } from 'aws-amplify/auth';
import { SystemError, SystemErrorTitle, SystemErrorMsg } from "../../constants";

/** 'アカウント情報一覧 */
const accountList = async () => {
  // 認証
  const session = await fetchAuthSession();
  const contractInfo = JSON.parse(session?.tokens?.idToken?.payload.contractInfoData?.toString() || "[]");
  const detailsManagementNo = contractInfo.length !== 0 && contractInfo[0].detailsManagementNo;
  const sessionId = session.tokens?.idToken?.payload?.sessionId;
  const jwtToken = session.tokens?.idToken?.toString();
  // EyesFrontAPIのURLを取得
  const baseURL = process.env.REACT_APP_EYES_FRONT_API_ROOT!;
  // アカウント情報一覧API PATH
  const path = "/account/list/execution";
  const request = {
    "detailsManagementNo": detailsManagementNo,
    "sessionId": sessionId
  };

  try {
    const response = await executeApi(baseURL, path, jwtToken, 0, request);
    // レスポンスコード返却
    if (!response || response.data.resCd == "") {
      return {
        resCd: SystemError,
        msgTitle: SystemErrorTitle,
        msg: SystemErrorMsg
      }
    } else {
      return response.data
    }
  } catch (e) {
    return {
      resCd: SystemError,
      msgTitle: SystemErrorTitle,
      msg: SystemErrorMsg
    };
  }
};

export default accountList;